module.exports = "/static/assets/91935ca9beb1c941b4acfae2115578cc.png";